import React from "react";
import MinigraphCard from "./minigraphCard";
import PropTypes from "prop-types";
import axios from "axios";
import { I18n } from "i18n-js";
import * as locales from "../../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";
import setUpAxios from "../../../helperFunctions/helperFunctions";
import { ResponsiveCalendar } from "@nivo/calendar";
import Spinner from "../../reusable/spinner";

declare var moment: any;

export default class CalendarCard extends React.Component<any, any> {
  componentDidMount() {
    setUpAxios();
    this.getData();
  }

  state = {
    data: [],
    loading: true,
  };

  render() {
    return (
      <MinigraphCard title={this.getTitle()} url={this.getUrl()}>
        {this.renderContent()}
      </MinigraphCard>
    );
  }

  renderContent = () => {
    if (this.state.loading) {
      return this.renderLoadingState();
    }

    if (this.state.data.length === 0) {
      return this.renderErrorState();
    }

    return <>{this.renderGraph()}</>;
  };

  renderGraph = () => {
    return (
      <div style={{ height: 200 }}>
        <ResponsiveCalendar
          data={this.state.data}
          from={moment().subtract(90, "days").format("L")}
          to={moment().subtract(0).format("L")}
          emptyColor="#eeeeee"
          colors={["#61cdbb", "#97e3d5", "#e8c1a0", "#f47560"]}
          margin={{ top: 40, right: 40, bottom: 40, left: 40 }}
          yearSpacing={40}
          monthBorderColor="#ffffff"
          dayBorderWidth={2}
          dayBorderColor="#ffffff"
          legends={[
            {
              anchor: "bottom-right",
              direction: "row",
              translateY: 36,
              itemCount: 4,
              itemWidth: 42,
              itemHeight: 36,
              itemsSpacing: 14,
              itemDirection: "right-to-left",
            },
          ]}
        />
      </div>
    );
  };

  renderLoadingState = () => {
    return (
      <div className="notification-container">
        <Spinner />
      </div>
    );
  };

  renderErrorState = () => {
    return (
      <div className="notification-container">
        <div className="alert alert-warning">
          <i className="fa fa-exclamation-triangle" />
          {i18n.translate("analyticsv2.participation.not_enough_data")}
        </div>
      </div>
    );
  };

  getTitle = () => {
    return "Bonuses Given";
  };

  getUrl = () => {
    return "#";
  };

  getData = () => {
    axios.get("/api/v1/analytics/calendar").then((response) => {
      this.setState({
        data: response.data,
        loading: false,
      });
    });
  };
}
